import './MuiClassNameSetup'; // First import for override.

import React, { Component } from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeContext } from './context/ThemeContext';

class ItrvlThemeProvider extends Component {
  render() {
    const theme = this.props.value.theme;
    const value = this.props.value;
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ThemeContext.Provider value={value}>{this.props.children}</ThemeContext.Provider>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

export default ItrvlThemeProvider;
